import { appConfig } from '../../../config/customization';
import { message } from '../../../utils/stringUtils';

import PersonalInformation from './components/PersonalInformation';
import IdentityValidation from './components/IdentityValidation';
import UserRegister from './components/UserRegister';
import EmailValidation from './components/EmailValidation';
import AddAccount from './components/AddAccount';
import AccountRelationshipValidation from './components/AccountRelationshipValidation';
import RelatedAccounts from './components/RelatedAccounts';
import TermsAndConditions from './components/TermsAndConditions';
import ServiceAdherence from './components/ServiceAdherence';

export const isActive = step => appConfig.signUpFlow[step.componentName];

export const steps = [
  {
    stepNumber: 1,
    component: PersonalInformation,
    componentName: 'PersonalInformation',
    action: message('SignUpProgress:action1'),
    item: message('SignUpProgress:item1')
  },
  {
    stepNumber: 2,
    component: IdentityValidation,
    componentName: 'IdentityValidation',
    action: message('SignUpProgress:action2'),
    item: message('SignUpProgress:item2')
  },
  {
    stepNumber: 3,
    component: UserRegister,
    componentName: 'UserInformation',
    action: message('SignUpProgress:action3'),
    item: message('SignUpProgress:item3')
  },
  {
    stepNumber: 4,
    component: TermsAndConditions,
    componentName: 'TermsAndConditions',
    action: message('SignUpProgress:action8'),
    item: message('SignUpProgress:item8')
  },
  {
    stepNumber: 5,
    component: EmailValidation,
    componentName: 'EmailValidation',
    action: message('SignUpProgress:action4'),
    item: message('SignUpProgress:item4')
  },
  {
    stepNumber: 6,
    component: AddAccount,
    componentName: 'AddAccount',
    action: message('SignUpProgress:action5'),
    item: message('SignUpProgress:item5')
  },
  {
    stepNumber: 7,
    component: AccountRelationshipValidation,
    componentName: 'AccountRelationshipValidation',
    action: message('SignUpProgress:action6'),
    item: message('SignUpProgress:item6')
  },
  {
    stepNumber: 8,
    component: ServiceAdherence,
    componentName: 'ServiceAdherence',
    action: message('SignUpProgress:action7'),
    item: message('SignUpProgress:item7')
  },
  {
    stepNumber: 9,
    component: RelatedAccounts,
    componentName: 'RelatedAccounts',
    action: message('SignUpProgress:action7'),
    item: message('SignUpProgress:item7')
  },
  {
    stepNumber: 10,
    component: ServiceAdherence,
    componentName: 'ServiceAdherence',
    action: message('SignUpProgress:action7'),
    item: message('SignUpProgress:item7')
  }
];
